import {
  and,
  asc,
  catalog_product,
  collector_profile,
  desc,
  eq,
  type PowerSyncDrizzleDB,
  profile_favorite,
  profile_featured,
  profile_tag,
} from "@famidex/powersync";

/**
 * 🧑‍🎨 PERFIL DEL COLECCIONISTA — lecturas del cliente. Todo PRIVADO y aislado
 * por usuario (stream `my_profile`, `WHERE user_id = auth.user_id()`). Los
 * destacados/favoritos/etiquetas se resuelven con un JOIN reactivo contra el
 * catálogo global (`catalog_product`, ya en la DB local por `catalog_public`).
 */

/** Ajustes del perfil (privacidad + marco + bio). A lo sumo una fila. */
export function getCollectorProfileQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db.select().from(collector_profile).where(eq(collector_profile.user_id, userId)).limit(1);
}

/** Destacados (máx. 5) del usuario, resueltos contra el catálogo, en orden. */
export function getFeaturedQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      id: profile_featured.id,
      product_id: profile_featured.product_id,
      sort_order: profile_featured.sort_order,
      edition_name: catalog_product.edition_name,
      image_url: catalog_product.image_url,
      category: catalog_product.category,
      is_limited: catalog_product.is_limited,
    })
    .from(profile_featured)
    .innerJoin(catalog_product, eq(profile_featured.product_id, catalog_product.id))
    .where(eq(profile_featured.user_id, userId))
    .orderBy(asc(profile_featured.sort_order));
}

/** Sólo los product_ids destacados (para el toggle de la ficha, sin join). */
export function getFeaturedIdsQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({ id: profile_featured.id, product_id: profile_featured.product_id })
    .from(profile_featured)
    .where(eq(profile_featured.user_id, userId))
    .orderBy(asc(profile_featured.sort_order));
}

/** Favoritos del usuario, resueltos contra el catálogo (pestaña favoritos). */
export function getFavoritesQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      id: profile_favorite.id,
      product_id: profile_favorite.product_id,
      created_at: profile_favorite.created_at,
      edition_name: catalog_product.edition_name,
      image_url: catalog_product.image_url,
      category: catalog_product.category,
    })
    .from(profile_favorite)
    .innerJoin(catalog_product, eq(profile_favorite.product_id, catalog_product.id))
    .where(eq(profile_favorite.user_id, userId))
    .orderBy(desc(profile_favorite.created_at));
}

/** Etiquetas del usuario, resueltas contra el catálogo (pestaña etiquetas). */
export function getTagsQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      id: profile_tag.id,
      product_id: profile_tag.product_id,
      label: profile_tag.label,
      edition_name: catalog_product.edition_name,
      image_url: catalog_product.image_url,
    })
    .from(profile_tag)
    .innerJoin(catalog_product, eq(profile_tag.product_id, catalog_product.id))
    .where(eq(profile_tag.user_id, userId))
    .orderBy(asc(profile_tag.label));
}

/** ¿Está este producto entre los favoritos del usuario? (para el toggle). */
export function getFavoriteByProductQuery(
  db: PowerSyncDrizzleDB,
  userId: string,
  productId: string,
) {
  return db
    .select({ id: profile_favorite.id })
    .from(profile_favorite)
    .where(and(eq(profile_favorite.user_id, userId), eq(profile_favorite.product_id, productId)))
    .limit(1);
}
